export function observeScrollbarWidth() {
  const config = {
    threshold: 1.0
  };

  const handleIntersect = (entries) => {
    entries.forEach(entry => {
      let scrollbarWidth = 0;

      if (entry.intersectionRatio < 1) {
        // scrollbarWidth = window.innerWidth - document.body.clientWidth;
        scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      }

      document.documentElement.style.setProperty('--stzh-scrollbar-width', scrollbarWidth + 'px');
      document.documentElement.style.setProperty('--stzh-scrollbar-active', scrollbarWidth > 0 ? '1' : '0');
    });
  };

  const bodyScrollObserver = new IntersectionObserver(handleIntersect, config);
  bodyScrollObserver.observe(document.body);
}
